import { FormFieldFileUploadArray } from '@publishing-engine/domain/types/article';

// This is to re-use existing FormField File Array component
export const getFileUploadArrayFFDConfigs = (
  name: string
): FormFieldFileUploadArray => {
  return {
    component: 'Custom:FileUploadArray',
    name: name,
    params: {
      validations: {
        kind: 'fileArray',
        maxSizeMB: 25,
        allowedFileFormats: {
          'application/pdf': ['.pdf'],
          'application/msword': ['.doc'],
          'application/vnd.openxmlformats': ['.docx']
        },
        required: false
      },
      labels: {
        main: 'Attach Files',
        subtitle: 'Attach files to support your response if needed.'
      }
    },
    caseDataFields: {
      main: name
    }
  };
};
